import React, { useEffect, useState } from "react";
import { getPatientSymptoms } from "../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import { Button } from "react-bootstrap";
import eyeimg from "../../images/eye.svg";
import Loader from "../../utils/Loader";

import "./SymtomsList.css";
export default function SymtomsList({ data }) {
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [symptomList, setSymptomList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewModel, setViewModel] = useState(false);
  const [viewData, setViewData] = useState(null);

  useEffect(() => {
    __getPatientSymptoms();
  }, [data, page, limit]);

  const __getPatientSymptoms = async () => {
    try {
      setLoading(true);
      const response = await getPatientSymptoms(data, {
        page: page + 1,
        limit,
      });
      if (response?.status === "SUCCESS") {
        setSymptomList(response?.data?.list || []);
        setTotalItems(response?.data?.totalItems);
        setTotalPages(response?.data?.totalPages);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.message);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  // ******************************Pagination logic ***********************************************************
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Function to get string based on number
  function getUrgencyString(number) {
    switch (number) {
      case 0:
        return "Not at all";
      case 1:
        return "Less than half the time";
      case 2:
        return "About half the time";
      case 3:
        return "More than half the time";
      case 4:
        return "Almost always";
      default:
        return "Invalid number";
    }
  }

  // Function to get string based on number
  function getSleepImpact(number) {
    switch (number) {
      case 0:
        return "Not at all";
      case 1:
        return "Yes, Somewhat";
      case 2:
        return "Yes, a Lot";
      default:
        return "Invalid number";
    }
  }

  const handleClose = () => setViewModel(false);

  return (
    <>
      {loading && <Loader />}
      {/* table for tratment lis  */}
      <div className="table-responsive dashboard-table">
        <table className="patients-table">
          <thead>
            <tr className="t-row-block">
              <th scope="col">Sr No</th>
              {/* <th scope="col">Patient Name</th> */}
              <th scope="col">Urinary Frequency</th>
              <th scope="col">Bothered</th>
              <th scope="col">Urgency</th>
              <th scope="col">Bladder Pain</th>
              <th scope="col">Date</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {symptomList?.length > 0 ? (
              symptomList?.map((symptom, index) => (
                <tr key={symptom.id || index}>
                  <td scope="row" style={{ borderLeft: "0px" }}>
                    {++index}
                  </td>
                  <td>{symptom?.urinaryFrequency}</td>
                  <td>
                    {symptom?.bothered
                      ?.split("_")
                      .map(
                        (word) =>
                          word.charAt(0).toUpperCase() +
                          word.slice(1).toLowerCase()
                      )
                      .join(" ")}
                  </td>
                  <td>{getUrgencyString(symptom?.urgency || 0)}</td>

                  <td>{symptom?.bladderPain || 0}</td>

                  <td>{symptom?.createdAt?.split("T")[0] || "-"}</td>

                  <td>
                    <a
                      className="edit-del-icon eye-edit-del eye-img"
                      onClick={() => {
                        setViewModel(true);
                        setViewData(symptom);
                      }}
                    >
                      <img src={eyeimg} alt="view" />
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No symptoms Found
                </td>
              </tr>
            )}

            <tr></tr>
          </tbody>
        </table>
      </div>

      {viewModel && (
        <div className="symptoms">
          <div className=" symptoms modal-overlay">
            <div className="modal-content">
              {/* Header */}
              <div className="modal-header">
                <h2>Details</h2>
                <button className="close-btn" onClick={handleClose}>
                  &times;
                </button>
              </div>

              {/* Body */}
              <div className="modal-body">
                <form className="aling-center">
                  {/* First Row */}
                  <div className="row border p-2 pt-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Urinary Frequency</label>
                        <p>{viewData?.urinaryFrequency}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Urgency</label>
                        <p>{getUrgencyString(viewData?.urgency)}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Bothered</label>
                        <p>
                          {viewData?.bothered
                            ?.split("_")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(" ")}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="row border p-2 pt-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Pain Location</label>
                        <p>{viewData?.painLocation}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Sleep Impact</label>
                        <p>{getSleepImpact(viewData?.sleepImapact || 0)}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Bladder Pain</label>
                        <p>{viewData?.bladderPain || "-"}</p>
                      </div>
                    </div>
                  </div>

                  {/* Fluid Intake Row */}
                  <div className="row border p-2 pt-3">
                    <div className="col-12">
                      <div className="form-group">
                        <label>Fluid Intake</label>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <p>Alcohol: {viewData?.fluidIntake?.alcohol || 0}</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <p>water: {viewData?.fluidIntake?.water || 0}</p>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <p>Coffee: {viewData?.fluidIntake?.coffee || 0}</p>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <p>Juice Tea: {viewData?.fluidIntake?.juiceTea || 0}</p>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <p>Milk: {viewData?.fluidIntake?.milk || 0}</p>
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        <p>
                          Soft Drink: {viewData?.fluidIntake?.softdrinks || 0}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* notes Row */}
                  <div className="row border p-2 pt-3">
                    <div className="col-12">
                      <div className="form-group">
                        <label>Notes</label>
                        <p>{viewData?.notes || "-"}</p>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              {/* Footer */}
              <div className="modal-footer m-0">
                <Button
                  className="btn btn-primary outlined-btn"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}
